import mutations from './mutations'

import { loadItemsBuilder } from '../crudFactory'
const apiEndpoint = 'premiseTypes'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint })
  },

  mutations: {
    ...mutations
  }
}
